import { Button, Collapse, Input, Tag, Upload } from "antd";
import { GlobalOutlined, UploadOutlined } from "@ant-design/icons";
import { EditText, EditTextarea } from "react-edit-text"; // assuming you're using this lib
import { v4 as uuidv4 } from "uuid";

const ButtonTemplateComp = ({
  data,
  onChange,
  postId,
  handleBtnNameChange,
  handleBtnURLChange,
  onRemove,
  handleImageUpload,
  thumnailURL,
  AccessOrNot,
  CrownReturn
}) => {
  return (
    <>
      <div className="btn-tmp-bldr">
        {data?.cover_image && (
          <div className="img-box">
            <img
              style={{
                maxWidth: "100%",
                maxHeight: "200px",
                borderRadius: "inherit",
                objectFit: "cover",
                width: "100%",
              }}
              src={data?.cover_image}
              alt="cover"
            />
          </div>
        )}

        <div
          style={
            data?.cover_image === undefined
              ? { marginTop: "40px", padding: "20px" }
              : { marginTop: "10px", padding: "10px" }
          }
        >
          <EditTextarea
            style={{
              width: "90%",
              overflow: "hidden",
              padding: "10px",
              fontWeight: "bold",
              maxWidth: "100%",
              display: "block !important",
            }}
            rows={1}
            inline
            onSave={(e) => onChange({ ...data, title: e.value })}
            defaultValue={data?.title || "Click to edit title"}
          />

          <EditTextarea
            style={{ width: "90%", padding: "10px", fontSize: "12px" }}
            onSave={(e) => onChange({ ...data, subtitle: e.value })}
            inline
            rows={1}
            defaultValue={data?.subtitle || "Click to edit description"}
          />
          {data?.buttons?.map((item, index) => (
            <div className="msg-btn" style={{ paddingBottom: "10px" }} key={index}>
              <Collapse
                style={{ textAlign: "center", backgroundColor: "white" }}
                items={[
                  {
                    key: "1",
                    label: item.title,
                    children: (
                      <div className="edit-input">
                        <Input
                          prefix={"T"}
                          style={{ marginBottom: "20px" }}
                          placeholder="Button Text"
                          onChange={(e) => 
                            
                            {
                            let new_btns = [...data.buttons]
                            new_btns[index].title = e.target.value
                            onChange({
                              ...data,
                              buttons: new_btns
                            })
                        
                          }}
                          value={item.title}
                        />
                        <Input
                          prefix={<GlobalOutlined />}
                          style={{ marginBottom: "10px" }}
                          placeholder="Button URL"
                          onChange={(e) => 
                            
                            {
                            let new_btns = [...data.buttons]
                            new_btns[index].url = e.target.value
                            onChange({
                              ...data,
                              buttons: new_btns
                            })
                        
                          }}
                          
                          value={item.url}
                        />
                        <Button danger block onClick={() => {
                          let new_btns = [...data.buttons]
                          new_btns.splice(index, 1);
                          onChange({
                              ...data,
                              buttons: new_btns
                            })}}>
                          Remove Button
                        </Button>
                      </div>
                    ),
                    showArrow: false,
                  },
                ]}
              />
            </div>
          ))}
        </div>
      </div>

      {data?.buttons?.length < 3 && (
        <Button
          disabled={AccessOrNot("button_template", true, data.buttons.length)}
          onClick={() =>
            onChange({
              ...data,
              buttons: [
                ...data.buttons,
                { title: "click to edit", url: "", type: "web_url" },
              ],
            })
          }
          block
          style={{ height: "40px", margin: "auto", marginTop: "20px" }}
        >
          Add more button
        </Button>
      )}

      {AccessOrNot("button_template", true, data?.buttons?.length) &&
        data?.buttons?.length >= 3 && (
          <Tag style={{ marginTop: "20px" }} color="red">
            Button Limit reached. Upgrade your plan{" "}
            <CrownReturn limit_reached={true} />
          </Tag>
        )}

      <Upload
        action=""
        accept="image/*"
        beforeUpload={() => false}
        listType="picture"
        defaultFileList={
          data?.cover_image
            ? [
                {
                  name: uuidv4() + ".jpg",
                  uid: uuidv4(),
                  thumbUrl: data.cover_image,
                  url: data.cover_image,
                  status: "done",
                },
              ]
            : []
        }
        onChange={({ file }) => handleImageUpload(file, (url) => {
          onChange({...data, cover_image: url})
        })}
        maxCount={1}
      >
        {data?.cover_image === undefined && (
          <Button
            type="default"
            variant="outlined"
            style={{ marginTop: "20px" }}
            icon={<UploadOutlined />}
            block
          >
            Upload Cover image
          </Button>
        )}
      </Upload>
    </>
  );
};

export default ButtonTemplateComp;
